<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title">YAN LIANKE</h1>
<h2 class="title">THE EXPLOSION CHRONICLES</h2>
<h3 class="title">Translated from the Chinese by Carlos Rojas</h3>
<p class="title"><img alt="" src="OEBPS/images/logo.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?6c043410